import React from "react";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import withMobileDialog from "@material-ui/core/withMobileDialog";

class DisclaimerDialog extends React.Component {
  render() {
    const { open, onClose } = this.props;

    return (
      <Dialog
        fullScreen={false}
        open={open}
        onClose={() => onClose()}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {"Please read and agree to the terms"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText component="div">
            <p>
              I know that running a trail run is a potentially hazardous
              activity, which could cause injury or death. I will not enter and
              participate unless I am medically able and properly trained, and
              by my consent, I certify that I am medically able to perform this
              event, and am in good health, and I am properly trained.
            </p>
            I agree to abide by any decision of a run official relative to any
            aspect of my participation in this event, including the right of any
            official to deny or suspend my participation for any reason
            whatsoever. I attest that I have read the rules of the race and
            agree to abide by them. I assume all risks associated with
            participating in this event, including but not limited to: falls,
            contact with other participants, the effects of the weather,
            including high heat and/or humidity, lightning, the conditions of
            the unpaved route including but not limited to trip hazards such as
            holes, roots, stones, rocks and ditches, the threat of wild animals
            such as snakes and all such risks being known and appreciated by me.
            <p>
              I understand that bicycles, skateboards, baby joggers, roller
              skates or roller blades, animals, and personal music players are
              not allowed in the run and I will abide by all event rules.{" "}
            </p>{" "}
            <p>
              Having read this waiver and knowing these facts and in
              consideration of your accepting my entry, I, for myself and anyone
              entitled to act on my behalf, waive and release the Gaborone Golf
              Club 5kms event, the event organizers and volunteers, the Gaborone
              Golf Club, the city of Gaborone all event sponsors, their
              representatives and successors from all claims or liabilities of
              any kind arising out of my participation in this event, even
              though that liability may arise out of negligence or carelessness
              on the part of the persons named in this waiver.
            </p>
            <p>
              {" "}
              I grant permission to all of the foregoing to use my photographs,
              motion pictures, recordings or any other record of this event for
              any legitimate purpose. I understand that as this event is free to
              enter it does not provide for refunds in the event of a
              cancellation, and by consenting to this waiver, I consent that I
              am not entitled to any compensation if the event is canceled
              before or during the event.
            </p>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => onClose("Disagree")} color="primary">
            Disagree
          </Button>
          <Button
            onClick={() => onClose("Agree")}
            color="secondary"
            autoFocus
            variant="contained"
            size="large"
          >
            Agree
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

DisclaimerDialog.propTypes = {
  fullScreen: PropTypes.bool.isRequired
};

export default withMobileDialog()(DisclaimerDialog);
